"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.District = void 0;
var React = require("react");
var District = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b;
    return (React.createElement("svg", { version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 24 24", xmlSpace: "preserve", style: style },
        React.createElement("g", null,
            React.createElement("polygon", { points: "20,13 20,11 13,11 13,9 11,9 11,11 4,11 4,13 6,13 6,15 8,15 8,13 16,13 16,15 18,15 \n\t\t18,13 \t" }),
            React.createElement("path", { d: "M16,16h2c0.6,0,1,0.4,1,1v2c0,0.6-0.4,1-1,1h-2c-0.6,0-1-0.4-1-1v-2\n\t\tC15,16.4,15.4,16,16,16z" }),
            React.createElement("path", { d: "M6,16h2c0.6,0,1,0.4,1,1v2c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1v-2C5,16.4,5.4,16,6,16z" }),
            React.createElement("path", { d: "M11,4h2c0.6,0,1,0.4,1,1v2c0,0.6-0.4,1-1,1h-2c-0.6,0-1-0.4-1-1V5C10,4.4,10.4,4,11,4z" }))));
};
exports.District = District;
//# sourceMappingURL=District.js.map